import { FF_DARK_MODE, FF_NEW_DASHBOARD, FEATURE_TASK_COMMENTS, FEATURE_AI_SUGGESTIONS, FF_ENABLE_WEBSOCKET } from "../config";

const featureFlags: Record<string, boolean> = {
  FF_DARK_MODE,
  FF_NEW_DASHBOARD,
  FF_ENABLE_WEBSOCKET,
  FEATURE_TASK_COMMENTS,
  FEATURE_AI_SUGGESTIONS,
  FEATURE_EXPORT_CSV: true,
  FEATURE_BULK_ACTIONS: false,
  FF_BETA_UI: import.meta.env.VITE_FF_BETA_UI === "true",
};

export function isFeatureEnabled(key: string): boolean {
  return featureFlags[key] ?? false;
}

export function useFeatureFlag(key: string): boolean {
  return isFeatureEnabled(key);
}

export function getAllFlags(): Record<string, boolean> {
  return { ...featureFlags };
}
